import { render, staticRenderFns } from "./WrapperTablesBalance.vue?vue&type=template&id=5495e459&"
import script from "./WrapperTablesBalance.vue?vue&type=script&lang=js&"
export * from "./WrapperTablesBalance.vue?vue&type=script&lang=js&"
import style0 from "./WrapperTablesBalance.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports